export default "__VITE_ASSET__9440eace__"